'use client'

import { useTranslations } from 'next-intl'

import { URLS } from '@/configs/urls'
import { Link } from '@/i18n/routing'
import Button from '@/shared/ui/Button'

import S from './NotFound.module.scss'

const NotFound = () => {
  const t = useTranslations('notFoundPage')

  return (
    <section className={S.page}>
      <div className={S.glow} aria-hidden="true" />
      <div className={S.content}>
        <p className={S.code}>{t('code')}</p>
        <h1 className={S.title}>{t('heading')}</h1>
        <p className={S.description}>{t('description')}</p>
        <Link href={URLS.MAIN} className={S.action}>
          <Button color="color">{t('backHome')}</Button>
        </Link>
      </div>
    </section>
  )
}

export default NotFound
